<template>
  <div class="keySpecial">
    <div class="body-content">
      <div class="main-content">
        <ul>
          <li>
            <p class="name pointer">沈鋆, 彭恒, 陈浩峰,等. 基于线性匹配法(LMM)的承压部件安定棘轮分析与评定[J]. 压力容器, 2018, 035(006):24-30.</p>
            <p class="content">基于现代结构健康检测(SHM)系统方法,将阻尼减震器用于侧框架塔结构设计,以某炼化工程中的大型侧框架塔为对象,考虑塔体与框架不同连接,利用ABAQUS有限元软件对其进行自振特性分析和7度罕遇地震作用下动力响应分析。计算结果表明,塔体和框架之间连接方式能影响结构的自振特性,弹簧刚度越大、侧框架塔基频越高;在地震作用…</p>
            <p class="date">2020-09-11 16:24</p>
          </li>
          <li>
            <p class="name pointer">周如瑶，2016级测试计量技术及仪器学术硕士，硕士论文题名《微电网中风机叶片冲蚀磨损试验与模拟研究》</p>
            <p class="content">针对风机叶片冲蚀磨损问题，论文设计和搭建了固体颗粒冲蚀磨损试验台，通过改变冲击速度、颗粒粒径和冲击角度这三个影响因素分别对试样材料进行冲蚀磨损试验。基于试验结果计算得出仿真数学模型中的相关函数，并将参数修正到仿真数学模型中。利用CFD软件对叶片试样级别进行数值模拟，得出了上述三个因素对风机叶片冲蚀磨损过程…</p>
            <p class="date">2020-09-11 16:24</p>
          </li>
          <li>
            <p class="name pointer">混合式角度测量系统</p>
            <p class="content">项目完全实现了任务书预期研究目标，建立了一套完整的混合式角度测量系统，与国家激光小角度基准、面角度基准、线角度基准一一对应，将激光反正弦测角、多面棱体测角、圆光栅测角原理一体化集成。其他国家计量院均只基于单一测量原理研制角度计量标准装置，具备如下显著的优点：（1）实现了全测量空间内不同测量原理的实时混合，实时相验…</p>
            <p class="date">2020-09-11 16:24</p>
          </li>
          <li>
            <p class="name pointer">水下电声参数测量</p>
            <p class="content">该专著详细的介绍了水听器灵敏度测量、水声换能器电声参数测量、大孔径基阵声参数测量、水下声场特性测量和水声构建声特性测量等内容，内容丰富、基本覆盖了换能器和水听器测量的内容。</p>
            <p class="date">2020-09-11 16:24</p>
          </li>
          <li>
            <p class="name pointer">论文</p>
            <p class="content">已经发表SCI/EI收录论文4篇。[1]Lu L, Tao L, Yining W, et al. Research on Osteoporosis Risk Assessment Based on Semi-supervised Machine Learning[C]//Proceedings of the 2020 Artificial Intelligence and Complex Systems Conference. 2020: 114-120.（EI）…</p>
            <p class="date">2020-09-11 16:24</p>
          </li>
          <li>
            <p class="name pointer">CMC（8项）</p>
            <p class="content">氮中四氢噻吩2项，甲烷中四氢噻吩2项，氮中甲硫醇2项，甲烷中甲硫醇2项</p>
            <p class="date">2020-09-11 16:24</p>
          </li>
        </ul>

        <div class="pagination-box">
          <el-pagination
            background
            layout="prev, pager, next, total"
            :total="70">
          </el-pagination>
        </div>
      </div>
      <div class="keySpecial-slidebar">
        <div class="slidebar-item">
          <div class="item-header">
            <span class="name line1">相关机构</span>
          </div>
          <ul>
            <li class="title-item">中国计量科学研究院</li>
            <li class="title-item">中国测试技术研究院</li>
            <li class="title-item">中国检查检疫科学研究院</li>
            <li class="title-item">国际实验室认可合作组织</li>
          </ul>
        </div>
        <div class="slidebar-item">
          <div class="item-header">
            <span class="name line2">专题专栏</span>
            <span class="more pointer">
              更多<i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <ul>
            <li class="image-item">
              <div class="image-box">
                <img src="../../assets/images/home/zd@2x.png" alt="">
              </div>
            </li>
            <li class="image-item">
              <div class="image-box">
                <img src="../../assets/images/home/3@2x.png" alt="">
              </div>
            </li>
            <li class="image-item">
              <div class="image-box">
                <img src="../../assets/images/home/5@2x.png" alt="">
              </div>
            </li>
            <li class="image-item">
              <div class="image-box">
                <img src="../../assets/images/home/6@2x.png" alt="">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.body-content {
  display: flex;
  width: @body-width;
  margin: 0 auto;
}
.keySpecial {
  .main-content {
    flex: 0 0 856px;
    margin-right: 24px;
    padding-top: 8px;
    ul {
      margin-bottom: 32px;
      li {
        padding: 24px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .name {
          margin-bottom: 12px;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          color: rgba(46, 92, 154, 1);
        }
        .content {
          margin-bottom: 32px;
          font-size: 14px;
          line-height: 28px;
          color: rgba(0, 0, 0, 0.65);
        }
        .date {
          font-size: 12px;
          line-height: 17px;
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    .pagination-box {
      padding-bottom: 60px;
      text-align: center;
    }
  }
  .keySpecial-slidebar {
    flex: 0 0 400px;
    .slidebar-item {
      padding-top: 32px;
      .item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 5px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .name {
          position: relative;
          padding-left: 12px;
          font-size: 24px;
          font-weight: 500;
          line-height: 33px;
          color: rgba(0, 0, 0, 1);
          &.line1::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            z-index: 1;
            transform: translateY(-50%);
            width: 2px;
            height: 16px;
            background-color: rgba(46, 92, 154, 1);
          }
          &.line2::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            z-index: 1;
            transform: translateY(-50%);
            width: 2px;
            height: 16px;
            background-color: rgba(170, 47, 51, 1);
          }
        }
        .more {
          font-size: 14px;
          color: rgba(143, 143, 143, 1);
          line-height: 20px;
          img {
            margin-left: 5px;
            width: 10px;
            vertical-align: middle;
          }
        }
      }
      ul {
        .text-item {
          padding: 16px 0 12px 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          .type-box {
            display: flex;
            align-items: flex-end;
            margin-bottom: 8px;
            span {
              &:nth-child(1) {
                margin-right: 8px;
                font-size: 16px;
                line-height: 22px;
                color: rgba(46, 92, 154, 1);
              }
              &:nth-child(2) {
                font-size: 12px;
                line-height: 17px;
                color: rgba(0, 0, 0, 0.45);
              }
            }
          }
          .text {
            font-size: 14px;
            line-height: 20px;
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .image-item {
          padding-top: 12px;
          &:first-child {
            padding-top: 16px;
          }
          .image-box {
            width: 100%;
            height: 100px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .title-item {
          margin-bottom: 15px;
          width: 400px;
          height: 60px;
          border-radius: 6px;
          line-height: 60px;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          color: #fff;
          letter-spacing: 2px;
          text-shadow: 1px 1px 0px #2E5C9A;
          cursor: pointer;
          &:nth-child(1) {
            margin-top: 12px;
            background-color: rgba(125, 191, 237, 1);
          }
          &:nth-child(2) {
            background-color: rgba(126, 159, 217, 1);
          }
          &:nth-child(3) {
            background-color: rgba(124, 196, 253, 1);
          }
          &:nth-child(4) {
            margin-bottom: 0;
            background-color: rgba(109, 180, 205, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/keySpecial/index.vue